import AbstractEvent from "./AbstractEvent";

class StopStateEvent extends AbstractEvent {
    /** @inheritDoc */
    eventName = 'playost.stop';
}

export default  StopStateEvent;